// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AttachmentThumbnail-cls1__c9b40d16f0ac2c59d50c{/*!*/}.AttachmentThumbnail-cls2___cf3997bae5c1f36c64a{width:100%;max-height:119px;-o-object-fit:cover;object-fit:cover;-o-object-position:top left;object-position:top left;display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AttachmentThumbnail-cls1__c9b40d16f0ac2c59d50c",
	"cls2": "AttachmentThumbnail-cls2___cf3997bae5c1f36c64a AttachmentThumbnail-cls1__c9b40d16f0ac2c59d50c"
};
export default ___CSS_LOADER_EXPORT___;
